
import styled, { css } from "styled-components";

export const AddParticipantModalContainer = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 48px;
`;
export const AddParticipantModalClose = styled.div`
  position: absolute;
  right: 48px;
  top: 48px;
  cursor: pointer;
`;
export const AddParticipantModalHeader = styled.div``;
export const AddParticipantModalTitle = styled.div`
  color:  #002E5C;
  font-family: var(--GeneralAddParticipantModalTitleFont-family);
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; 
`;
export const AddParticipantModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const AddParticipantModalActions = styled.div`
  display: flex;
  align-items: center;
  gap: 17px;
  justify-content: flex-end;
  

  @media only screen and (max-width: 400px) { 
    flex-direction: column;
  }
`;
export const AddParticipantModalButton = styled.button`
  display: flex;
  height: 44px;
  padding: 8px 20px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  font-family: var(--GeneralAddParticipantModalButtonFont-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px; 
  ${props => props.primary && css`
    background-color: #2555EF;
    color: #FFFFFF;
    width: 126px;
  `}
  ${props => props.secondary && css`
    background-color: rgba(37, 85, 239, 0.08);
    color: #2555EF;
  `}
  
  ${props => props.disabled && css`
    opacity: 0.5;
    cursor: not-allowed;
  `}

  @media only screen and (max-width: 400px) { 
    width: 100%
  }
`;


export const AddParticipantModalField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  position: relative;
`;
export const AddParticipantModalContentLabel = styled.div`
color:  #002E5C;
  font-family: var(--GeneralAddParticipantModalContentLabelFont-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
`;

export const AddParticipantModalCheckbox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AddParticipantModalCheckboxLabel = styled.div`
  color: #5B7792;
  font-family: var(--GeneralAddParticipantModalCheckboxLabelFont-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; 
`;

export const Selection = styled.div`
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  position: relative;
  border-radius: 5px;
  border: 1px solid #E1E1E7;
  background: #FFFFFF;
  line-height: 32px;
  cursor: pointer;
  ${props => props.isActive && css`
    border: 1px solid  #C1CEF9;
    background: #F3F6F9;
  `}
`;

export const SelectionInput = styled.input`
    border: none;
    outline: none;
    background: transparent;
    color: #002E5C;
    font-family: var(--GeneralSelectionInputFont-family);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    width: ${props => props.width ? props.width : "10px"};
    /* padding-right: ${props => props.width ? "0px" : "1.5rem"}; */
    cursor: pointer;

    &::placeholder {
      color: #99ABBE;
    }
`;

export const SelectionActiveValue = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const SelectionActiveValueName = styled.div`
  color:  #002E5C;
  font-family: var(--GeneralSelectionActiveValueNameFont-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
`;

export const SelectionActiveValueNumber = styled.div`
  color: #5B7792;
  font-family: var(--GeneralSelectionActiveValueNumberFont-family);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
`;



export const SelectionArrow = styled.div`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
`;
export const LoadingContainer = styled.div`
  position: absolute;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
`;

export const ParticipantMenuList = styled.div`
  border-radius: 5px;
  border: 1px solid  #E6EAEF;
  background:  #FFFFFF;
  box-shadow: 0px 17px 20px 0px rgba(19, 30, 68, 0.08);
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 1000;
  position: fixed;
  width: 400px;
  left: 50%;
  transform: translateX(-50%);
  top: 50vh;

  @media only screen and (max-width: 400px) {
    width: 90%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const ParticipantMenuItem = styled.div``;
export const ParticipantMenuItemHead = styled.div`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 8px;
  border-radius: 5px 5px 0px 0px;
  background: #F3F6F9;
`;
export const ParticipantMenuItemIcon = styled.div``;
export const ParticipantMenuItemName = styled.div`
  color: #88889D;
  font-family: var(--GeneralParticipantMenuItemNameFont-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 19px;
`;
export const ParticipantMembers = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 20px;
`;
export const ParticipantMember = styled.div`
  display: flex;
  padding: 10px 20px 10px 40px;
  align-items: center;
  gap: 8px;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: #70A0EE;
  }
  &:hover .participant-member-name {
    font-weight: 600;
  }
  
  ${props => props.isActive && css`
    background-color: #70A0EE;
    .participant-member-name {
      font-weight: 600;
    }
  `}
  ${props => props.isDisabled && css`
    cursor: not-allowed;
    pointer-events: none;
    background-color: transparent;
    opacity: 0.5;
    &:hover {
      background-color: transparent;
    }
  `}
`;
export const ParticipantMemberIcon = styled.div``;
export const ParticipantMemberName = styled.div`
  color:  #002E5C;
  font-family: var(--GeneralParticipantMemberNameFont-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; 
  transition: all 0.1s ease-in-out;
  max-width: 80%;
  word-break: break-word;
`;
export const ParticipantMemberNumber = styled.div`
  color: #5B7792;
  font-family: var(--GeneralParticipantMemberNumberFont-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
  transition: all 0.2s ease-in-out;
`;


export const EmptyLoadingParticipantContainer = styled.div`
  margin: 2rem 0;
  text-align: center;
  width: 100%;
`


